import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

import { CompanyProvider } from "./context/CompanyProvider";
import { AuthProvider } from "./context/AuthContext";

// ✅ ADD THIS
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// ✅ CREATE CLIENT (PRODUCTION SAFE CONFIG)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 sec cache
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CompanyProvider>
          <App />
        </CompanyProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
